import { httpClient } from "../http/client";
import { RESULT_PREVIEW_BASIC_PASSWORD, RESULT_PREVIEW_BASIC_USERNAME } from "../constants/resultPreviewAuth";

export interface ResultPreviewParams {
  percentile: number;
  gender: string;
  category: string;
  exam: string;
}

export interface ResultPreviewResponse {
  collegesMatched: number;
  safeBets: number;
  reachPicks: number;
}

function previewAuthorizationHeader(): string {
  const credentials = `${RESULT_PREVIEW_BASIC_USERNAME}:${RESULT_PREVIEW_BASIC_PASSWORD}`;
  return `Basic ${btoa(credentials)}`;
}

export async function fetchResultPreview(params: ResultPreviewParams): Promise<ResultPreviewResponse> {
  const response = await httpClient.get<ResultPreviewResponse>("/api/v1/preview", {
    params: {
      percentile: params.percentile,
      gender: params.gender,
      category: params.category,
      exam: params.exam,
    },
    headers: {
      Accept: "application/json",
      Authorization: previewAuthorizationHeader(),
    },
  });

  return response.data;
}
